import { render, staticRenderFns } from "./CollaboardModal.vue?vue&type=template&id=0db37dea&scoped=true"
import script from "./CollaboardModal.vue?vue&type=script&lang=js"
export * from "./CollaboardModal.vue?vue&type=script&lang=js"
import style0 from "./CollaboardModal.vue?vue&type=style&index=0&id=0db37dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db37dea",
  null
  
)

export default component.exports